import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import FilterListIcon from '@material-ui/icons/FilterList';

import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper from '@material-ui/core/Popper';
import { API_DATE_FORMAT_FULL } from '../../../constants/date';
import format from 'date-fns/format';
import { DataTableColumnDatePicker } from './DataTableColumnDatePicker';
import PropTypes from 'prop-types';

const FilterPopper = styled(Popper)`
  z-index: 3;
  padding: 15px;
`;

export const DataTableColumnDatePickerWrapper = ({ setCurrentFilter }) => {
  const anchorEl = useRef(null);
  const classes = ['icon'];
  const currentDate = new Date();
  const currentDateFull = format(currentDate, API_DATE_FORMAT_FULL);

  const currentDateMinusWeek = new Date();
  currentDateMinusWeek.setDate(currentDateMinusWeek.getDate() - 6);
  const currentDateMinusWeekFull = format(currentDateMinusWeek, API_DATE_FORMAT_FULL);

  const [filterOpened, setFilterOpened] = useState(false);
  const [dateFrom, setDateFrom] = useState(currentDateMinusWeekFull);
  const [dateTo, setDateTo] = useState(currentDateFull);

  const toggleFilterDialog = () => {
    setFilterOpened(!filterOpened);
  };

  return (
    <>
      <FilterListIcon className={classes.join(' ')} ref={anchorEl} onClick={toggleFilterDialog} />

      <FilterPopper open={filterOpened} anchorEl={anchorEl.current}>
        <ClickAwayListener onClickAway={toggleFilterDialog}>
          <Paper>
            <DataTableColumnDatePicker
              dateFrom={dateFrom}
              dateTo={dateTo}
              currentDateFull={currentDateFull}
              onClose={toggleFilterDialog}
              setDateFrom={(date) => setDateFrom(date)}
              setDateTo={(date) => setDateTo(date)}
              setCurrentFilter={setCurrentFilter}
            />
          </Paper>
        </ClickAwayListener>
      </FilterPopper>
    </>
  );
};

DataTableColumnDatePickerWrapper.propTypes = {
  currentFilter: PropTypes.array,
  setCurrentFilter: PropTypes.func,
};
